import { useState, type FormEvent } from "react";
import { useAuth } from "../auth/AuthContext.js";
import { ApiError } from "../lib/api.js";
import { Icons } from "../components/Icons.js";

/** Écran de connexion (comptes provisionnés à l'étape 1 : pas d'inscription publique). */
export function LoginScreen() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setError(null);
    setBusy(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Connexion impossible.");
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <form className="login-card" onSubmit={onSubmit}>
        <div className="login-brand">
          <span className="login-brand-mark">
            <Icons.Mic size={20} />
          </span>
          Pensieve
        </div>
        <div className="login-sub">Connectez-vous à votre compte</div>

        <div className="login-field">
          <label htmlFor="email">E-mail</label>
          <input
            id="email"
            className="login-input"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="login-field">
          <label htmlFor="password">Mot de passe</label>
          <input
            id="password"
            className="login-input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button className="login-submit" type="submit" disabled={busy || !email || !password}>
          {busy ? "Connexion…" : "Se connecter"}
        </button>

        {error && <div className="login-error">{error}</div>}
      </form>
    </div>
  );
}
